import { render, staticRenderFns } from "./DonationTaskPage.vue?vue&type=template&id=764b7049&"
import script from "./DonationTaskPage.vue?vue&type=script&lang=js&"
export * from "./DonationTaskPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports